import axios from 'axios'
import { useEffect, useState } from 'react'

const useGetAllManagers = (payload, dependencies = []) => {
    const [data, setData] = useState([]);

    useEffect(() => {
        
        axios.post(process.env.REACT_APP_BASE_URL + '/emp/getallemp', payload)
            .then((res) => {
                if (Array.isArray(res?.data?.data) && res.data.data.length > 0) {
                    const resultOptions = res.data.data.map((itm) => {
                        return ({
                            value: itm.empId,
                            label: `${itm.firstName} ${itm.lastName}`
                        })
                    })

                    setData(resultOptions)
                } else {
                    setData([])
                }

            })
            .catch((err) => {
                console.error("Error", err)
            })
    }, dependencies)

    return { data }
}

export default useGetAllManagers;
